import React from 'react';
import { forwardRef, Box, BoxProps, Icon, Text, TextProps, TypeIconName } from '@bitrise/bitkit';

export type BuildMetaDataProps = { icon?: TypeIconName; textProps?: TextProps } & BoxProps;
const BuildMetaData = forwardRef(
  (
    { icon, children, gap = '4', color = 'purple.10', textColor = 'purple.10', textProps, ...rest }: BuildMetaDataProps,
    ref,
  ) => (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems="center"
      gap={gap}
      color={color}
      textColor={textColor}
      ref={ref}
      {...rest}
    >
      {icon && <Icon name={icon} width="16px" height="16px" />}
      {children && (
        <>
          {React.Children.toArray(children).every((i) => typeof i === 'string' || typeof i === 'number') ? (
            <Text size="2" lineHeight="16px" {...textProps}>
              {children}
            </Text>
          ) : (
            children
          )}
        </>
      )}
    </Box>
  ),
);

export default BuildMetaData;
